import { createStore } from 'redux';

const SET_LANGUAGE = 'SET_LANGUAGE';

const initialState = {
  currentLanguage: 'en',
  
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        currentLanguage: action.payload,
      };
    default:
      return state;
  }
};

// Create the Redux store
const store = createStore(reducer);

export default store;